module.exports = __webpack_public_path__ + "img/pdf.58734b39.svg";